__webpack_require__.p = "/dist/gui/bkconfigurator/";